import { PrimaryButton, SecondaryButton } from "@common/Buttons";
import { Input } from "antd";
import { useEffect, useState } from "react";

export default function EditCellPopover({
  open,
  initialValue,
  fieldLabel,
  isSaving,
  onCancel,
  onSave,
}) {
  const [inputValue, setInputValue] = useState(initialValue ?? "");

  useEffect(() => {
    if (open) {
      setInputValue(initialValue ?? "");
    }
  }, [open, initialValue]);

  const handleStopPropagation = (e) => {
    e.stopPropagation();
  };

  const handleCancel = () => {
    setInputValue(initialValue ?? "");
    onCancel?.();
  };

  const handleSave = () => {
    const trimmed = inputValue.trim();
    const initialTrimmed = (initialValue ?? "").trim();

    if (trimmed === initialTrimmed) {
      onCancel?.();
      return;
    }

    onSave?.(trimmed);
  };

  return (
    <div
      className="flex flex-col gap-2 w-56"
      onClick={handleStopPropagation}
      onMouseDown={handleStopPropagation}
      role="dialog"
      aria-label={`Edit ${fieldLabel}`}
    >
      <Input
        size="small"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onPressEnter={handleSave}
        disabled={isSaving}
        className="!text-xs"
        aria-label={fieldLabel}
      />
      <div className="flex gap-2 justify-end">
        <SecondaryButton
          className="!h-7 !text-xs !px-3"
          onClick={handleCancel}
          disabled={isSaving}
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          className="!h-7 !text-xs !px-3"
          onClick={handleSave}
          loading={isSaving}
          disabled={isSaving}
        >
          Save
        </PrimaryButton>
      </div>
    </div>
  );
}
